/**
 * Intro screen for workflow legal ID — matches the existing IVA IntroScreen design.
 * Separate file, reuses same SCSS module for consistent styling.
 */

import { useTranslation } from "react-i18next";
import styles from "../legalIdVerification/LegalIdVerification.module.scss";

interface Props {
  onOpenCamera: () => void;
  onNoId: () => void;
}

export function WorkflowIntroScreen({ onOpenCamera, onNoId }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.card}>
      <h1 className={styles.title}>{t('legalId.ready.heading')}</h1>

      <div className={styles.docIllustration}>
        <img src="/assets/svg/legal-id-image.svg" alt={t('legalId.docIcon.alt')} width={219} height={172} />
      </div>

      <ul className={styles.infoList}>
        <li className={styles.infoItem}>
          <img src="/assets/svg/icon-id-card.svg" alt="" aria-hidden="true" className={styles.infoIcon} />
          <span className={styles.infoText}>{t('legalId.ready.info1')}</span>
        </li>
        <li className={styles.infoItem}>
          <img src="/assets/svg/icon-check-box.svg" alt="" aria-hidden="true" className={styles.infoIcon} />
          <span className={styles.infoText}>{t('legalId.ready.info2')}</span>
        </li>
      </ul>

      <button className={styles.openCameraButton} onClick={onOpenCamera}>
        {t('legalId.ready.button')}
      </button>

      <button className={styles.noIdLink} type="button" onClick={onNoId}>
        {t('legalId.ready.noId')}
      </button>
    </div>
  );
}
